/*
 * Header menu slider (bottom-menu layout).
 * The menu stays on one row inside a horizontally scrolling viewport with a
 * hidden scrollbar. The arrow button appears only when items are cut off: it
 * pages right, and at the end of the row it flips and returns to the start.
 * Trackpad, touch and keyboard focus still scroll the row natively.
 */
(function () {
  'use strict';

  function init(nav) {
    if (nav.dataset.navSliderReady) return;
    nav.dataset.navSliderReady = 'true';

    var viewport = nav.querySelector('[data-nav-slider-viewport]');
    var button = nav.querySelector('[data-nav-slider-button]');
    if (!viewport || !button) return;

    function atEnd() {
      return viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
    }

    function update() {
      var overflowing = viewport.scrollWidth > viewport.clientWidth + 2;
      button.hidden = !overflowing;
      nav.classList.toggle('has-more-left', overflowing && viewport.scrollLeft > 2);
      nav.classList.toggle('has-more-right', overflowing && !atEnd());
      if (!overflowing) return;
      var back = atEnd();
      button.classList.toggle('is-back', back);
      button.setAttribute('aria-label', button.getAttribute(back ? 'data-label-back' : 'data-label-next'));
    }

    button.addEventListener('click', function () {
      if (atEnd()) {
        viewport.scrollTo({ left: 0 });
      } else {
        viewport.scrollBy({ left: Math.max(120, viewport.clientWidth * 0.7) });
      }
    });

    var frame;
    viewport.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(viewport);
    } else {
      window.addEventListener('resize', update);
    }

    // Web fonts change the item widths once they load.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-nav-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme editor re-renders the header section.
  document.addEventListener('shopify:section:load', initAll);
})();
